import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Flex, Image, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ErrorIcon} from '../icons'

export const CHARM_SWATCH_LABEL_STYLES = {
    color: 'black.100',
    fontFamily: 'Inter',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    letterSpacing: '0.055px',
    lineHeight: 'normal',
    textAlign: 'center'
}

const CharmSwatchContent = ({image, isSoldOut = false, name}) => {
    const [hasImageError, setHasImageError] = useState(false)
    const imageSrc = image?.disBaseLink || image?.link

    useEffect(() => setHasImageError(false), [imageSrc])

    return (
        <Flex alignItems="center" flexDirection="column" width="100%">
            <Flex
                alignItems="center"
                backgroundColor="white"
                borderColor={isSoldOut ? 'gray.500' : 'transparent'}
                borderStyle="solid"
                borderWidth={isSoldOut ? '1px' : 0}
                boxSizing="border-box"
                height="80px"
                justifyContent="center"
                overflow="hidden"
                width="66px"
            >
                {hasImageError || !imageSrc ? (
                    <Flex
                        alignItems="center"
                        aria-hidden="true"
                        backgroundColor="gray.40"
                        height="100%"
                        justifyContent="center"
                        width="100%"
                    >
                        <ErrorIcon boxSize="19px" color="red.950" />
                    </Flex>
                ) : (
                    <Image
                        alt=""
                        height="100%"
                        objectFit="cover"
                        onError={() => setHasImageError(true)}
                        opacity={isSoldOut ? 0.5 : 1}
                        src={imageSrc}
                        width="100%"
                    />
                )}
            </Flex>
            <Text
                {...CHARM_SWATCH_LABEL_STYLES}
                color={isSoldOut ? 'gray.600' : CHARM_SWATCH_LABEL_STYLES.color}
                padding="7px 2px 8px"
                textDecorationLine={isSoldOut ? 'line-through' : 'none'}
                whiteSpace="normal"
                width="100%"
            >
                {name}
            </Text>
        </Flex>
    )
}

CharmSwatchContent.propTypes = {
    image: PropTypes.object,
    isSoldOut: PropTypes.bool,
    name: PropTypes.string
}

export default CharmSwatchContent
